"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";
import { HeroSubCardComponent } from "./HeroSubCardComponent";

export function HeroSubCardComponentContainer({}) {
  return (
    <Block className={"hero-card-container---component"} tag={"div"}>
      <Block className={"hero-card-container"} tag={"div"}>
        <HeroSubCardComponent
          description={
            "Schedule rent payments, submit maintenance requests, renew your lease and more."
          }
          icon={
            "https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/656bd2a03bf3058f0b5261d9_residents.svg"
          }
          linkLink={{
            href: "/residents/",
          }}
          linkText={"Resident Login"}
          title={"Residents"}
        />
        <HeroSubCardComponent
          description={
            "Welcome future neighbors! Find your new home and apply online."
          }
          icon={
            "https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/657b1b84ca3edfcfc1cc6b1a_chart.svg"
          }
          linkLink={{
            href: "/applicants/",
          }}
          linkText={"Find Your Home"}
          title={"Applicants"}
        />
        <HeroSubCardComponent
          description={
            "View our current job openings and apply for positions online."
          }
          icon={
            "https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/657b1b9200880656feb34777_bag.svg"
          }
          linkLink={{
            href: "https://careers-sares-regis.icims.com/jobs/intro?hashed=-435627079&mobile=false&width=940&height=500&bga=true&needsRedirect=false&jan1offset=-360&jun1offset=-300",
          }}
          linkText={"Join Our Team"}
        />
      </Block>
    </Block>
  );
}
